import AppContext from "PFApp/app_context";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useProfileInvalidate } from "PFCore/hooks/queries/profile";
import React, { useContext } from "react";
import { useUnmount } from "react-use";

import { BookingRowsContextProvider } from "./context/booking_rows_context";
import { BookingsOverviewContextProvider } from "./context/bookings_overview_context";
import Overview from "./overview";
import useRowChildrenInvalidate from "./side_panel_row/queries/use_row_children_invalidate";

const OverviewTab = (props) => {
  const {
    store: { currentAccount }
  } = useContext(AppContext);

  const { removeAllCache: removeAllRowChildrenCache } = useRowChildrenInvalidate();
  const { removeProfileBookingsCache, removeProfileWarningsCache, removeProfileAvailabilitiesCache } =
    useProfileInvalidate();
  useUnmount(() => {
    removeAllRowChildrenCache();
    removeProfileBookingsCache();
    removeProfileWarningsCache();
    removeProfileAvailabilitiesCache();
  });

  const WrappedTab = usePageWrapper(Overview);

  return <WrappedTab loading={!currentAccount.availability} {...props} />;
};

const OverviewTabWithContext = (props) => (
  <BookingsOverviewContextProvider>
    <BookingRowsContextProvider>
      <OverviewTab {...props} />
    </BookingRowsContextProvider>
  </BookingsOverviewContextProvider>
);

export default OverviewTabWithContext;
